import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://oqbneauhbtivohbyljaq.supabase.co';
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9xYm5lYXVoYnRpdm9oYnlsamFxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg5MTE0NTgsImV4cCI6MjA5NDQ4NzQ1OH0.awQ1H6PSxLo5HiSP8ZNTXVkQ2kB89Pxl0fnP_ubGBPs';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    // Throttle realtime events to reduce wakeups and battery drain on mobile.
    params: { eventsPerSecond: 5 },
  },
});
